<template>
  <form-main @back="makeSureBack">
    <template slot="nav">
      <div class="vita-form-nav">
        <p>完善个人资料<span style="font-size: 16px;color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(您填写的内容将后续用于颁发教练员证书和执照等，同时进入中国足协信息数据库，简历信息填写不完整将会影响更高一级教练员培训的录取)</span></p>
      </div>
    </template>
    <template slot="main">
      <div class="vita-form-main">
        <div class="content">
          <template v-if="!isLoading">
            <vue-scroll :ops="ops">
              <div class="form-wrap">
                <el-form :model="vitaForm"
                         :rules="rules"
                         ref="vitaForm"
                         label-width="100px"
                         size="medium">
                  <!-- 报名信息 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>报名信息</legend>
                    <el-row>
                      <el-col :span="16">
                        <el-form-item label="报名名称">
                          <el-input v-model.trim="vitaForm.enroll_name"
                            :disabled="true"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="注册足协" prop="org_id">
                          <el-select v-model="vitaForm.org_id"
                            clearable
                            filterable
                            placeholder="请选择注册足协">
                            <el-option
                              v-for="item in organList"
                              :key="item.org_id"
                              :label="item.org_abbreviation"
                              :value="item.org_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </fieldset>
                  <!-- 个人信息 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>个人信息</legend>
                    <el-form-item label-width="100px">
                      <el-row>
                        <el-col :span="9">
                          <!--<vita-card :imgUrl.sync="cardFront"
                                     tips="身份证正面"
                                     @imgChange="cardFrontImgChange"></vita-card>-->
                          <div class="idcard-front-end">
                            <vita-photo :w="260" :dw="'600px'" :h="160"
                                        :disabled="not_change"
                                        :imgUrl.sync="cardFront"></vita-photo>
                            <div v-show="showTipsFront"
                                 class="front-end-tips front-tips">
                              <img :src="tipsFront" alt="">
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="9">
                          <!--<vita-card :imgUrl.sync="cardBack"
                                     tips="身份证反面"
                                     @imgChange="cardBackImgChange"></vita-card>-->
                          <div class="idcard-front-end">
                            <vita-photo :w="260" :dw="'600px'" :h="160"
                                        :disabled="not_change"
                                        :imgUrl.sync="cardBack"></vita-photo>
                            <div v-show="showTipsEnd"
                                 class="front-end-tips end-tips">
                              <img :src="tipsEnd" alt="">
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="5" :offset="1">
                          <div class="photo">
                            <vita-photo :imgUrl.sync="photo" :disabled="not_change"></vita-photo>
                            <div v-show="showTipsPhoto"
                                 class="tips-photo">
                              <img :src="tipsPhoto" alt="">
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </el-form-item>
                    <el-row>
                      <el-col :span="7">
                        <el-form-item label="姓名" prop="name">
                          <el-input v-model.trim="vitaForm.name"
                            :disabled="true"
                            placeholder="请输入姓名"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="性别"
                          prop="gender"
                          class="gender">
                          <el-select v-model="noEdit.gender"
                            :disabled="true"
                            style="width: 137px"
                            placeholder="请选择性别">
                            <el-option
                              v-for="item in gender"
                              :key="item.val"
                              :label="item.key"
                              :value="item.val">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10" style="display: flex;align-items: center;height: 37px;padding-left: 35px">
                        <el-switch
                          v-model="switch_pinyin"
                          @change="changePinyin"
                        >
                        </el-switch>
                        <span  style="margin-left: 5px">姓名不区分姓氏和名的少数民族学员</span>
                      </el-col>
                    </el-row>
                    <el-row v-if="switch_pinyin">
                      <el-col :span="24">
                        <el-form-item label="姓名(拼音)" prop="family_name_spell">
                          <el-input v-model.trim="vitaForm.family_name_spell"
                            placeholder="姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-else>
                      <el-col :span="12">
                        <el-form-item label="姓氏(拼音)" prop="family_name_spell">
                          <el-input v-model.trim="vitaForm.family_name_spell"

                            placeholder="请输入拼音大写,例如张三,输入:ZHANG"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="名(拼音)" prop="given_name_spell">
                          <el-input v-model.trim="vitaForm.given_name_spell"
                            placeholder="请输入拼音大写,例如张三,输入:SAN"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="国籍" prop="nationality" class="national">
                          <el-select v-model="vitaForm.nationality"
                                     filterable
                                     placeholder="请选择国籍">
                            <el-option
                                v-for="item in countryArr"
                                :key="item.country_code"
                                :label="item.country_zh"
                                :value="item.country_code">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="护照号" prop="passport">
                          <el-input v-model.trim="vitaForm.passport"
                                    placeholder="请输入护照号"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="手机">
                          <el-input v-model="noEdit.phone"
                                    :disabled="true"
                                    placeholder="请输入手机号"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="出生日期"
                                      prop="date_of_birth">
                          <!--<el-form-item label="出生日期"
                                        prop="date_of_birth"
                                        class="birthday">
                            <el-date-picker
                                v-model="vitaForm.date_of_birth"
                                type="date"
                                :disabled="true"
                                placeholder="请选择日期">
                            </el-date-picker>-->
                          <el-input v-model="noEdit.birthDay"
                                    :disabled="true"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
<!--                    <el-row>-->
<!--                      <el-col :span="12">-->
<!--                        <el-form-item label="身高" prop="height">-->
<!--                          <el-input v-model.trim="vitaForm.height"-->
<!--                                    placeholder="请输入身高(单位/cm)"></el-input>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="12">-->
<!--                        <el-form-item label="体重" prop="weight">-->
<!--                          <el-input v-model.trim="vitaForm.weight"-->
<!--                                    placeholder="请输入体重(单位/kg)"></el-input>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
                    <el-row>
                      <el-col :span="10">
                        <el-form-item label="身高" prop="height">
                          <el-input v-model.trim="vitaForm.height"
                                    placeholder="请输入身高(单位/cm)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="2" style="padding: 10px;"><span>cm</span></el-col>
                      <el-col :span="10">
                        <el-form-item label="体重" prop="weight">
                          <el-input v-model.trim="vitaForm.weight"
                                    placeholder="请输入体重(单位/kg)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="2" style="padding: 10px;"><span>kg</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="11">
                        <el-form-item label="身份证号">
                          <el-input v-model.trim="noEdit.idNum"
                                    :disabled="true"
                                    placeholder="请输入身份证号"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="13">
                        <el-form-item label="电子邮箱" prop="email_address">
                          <el-input v-model.trim="vitaForm.email_address"
                                    placeholder="电子邮箱信息可用来找回帐号密码"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item label="伤病历史">
                      <el-input type="textarea"
                                :rows="1"
                                v-model.trim="vitaForm.medical_history"
                                placeholder="若有伤病史请输入"></el-input>
                    </el-form-item>
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="固定电话" >
                          <el-input v-model.trim="vitaForm.contact_numbers"
                                    placeholder="请输入固定电话"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="邮编(家)" prop="postcode">
                          <el-input v-model.trim="vitaForm.postcode"
                                    placeholder="请输入邮编"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="传真(家)" prop="fax_personage">
                          <el-input v-model.trim="vitaForm.fax_personage"
                                    placeholder="请输入传真"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item label="通信地址(家)">
                      <el-input type="textarea"
                                :rows="1"
                                v-model.trim="vitaForm.contact_address"
                                placeholder="请输入通信地址"></el-input>
                    </el-form-item>
                  </fieldset>
                  <!-- 单位信息 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>单位信息</legend>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="单位名称">
                          <el-input v-model.trim="vitaForm.club_name"
                                    placeholder="请输入单位名称"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="单位邮编" prop="club_postcode">
                          <el-input v-model.trim="vitaForm.club_postcode"
                                    placeholder="请输入单位邮编"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item label="单位地址">
                      <el-input type="textarea"
                                :rows="1"
                                placeholder="请输入单位地址"
                                v-model.trim="vitaForm.club_address"></el-input>
                    </el-form-item>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="电话" prop="club_telephone">
                          <el-input v-model.trim="vitaForm.club_telephone"
                                    placeholder="请输入单位电话"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="传真" prop="club_fax">
                          <el-input v-model.trim="vitaForm.club_fax"
                                    placeholder="请输入单位传真"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="网址">
                          <el-input v-model.trim="vitaForm.club_website"
                                    placeholder="请输入单位网址"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="电子邮箱" prop="club_email">
                          <el-input v-model.trim="vitaForm.club_email"
                                    placeholder="请输入单位电子邮箱"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </fieldset>
                  <!-- 装备尺码 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>装备尺码</legend>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="套服" prop="track_suit">
                          <el-select v-model="vitaForm.track_suit"
                                     placeholder="请选择套服尺码">
                            <el-option v-for="item in wearNum" :key="item" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="T恤" prop="polo_T">
                          <el-select v-model="vitaForm.polo_T"
                                     placeholder="请选择T恤尺码">
                            <el-option v-for="item in wearNum" :key="item" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="短裤" prop="shorts">
                          <el-select v-model="vitaForm.shorts"
                                     placeholder="请选择短裤尺码">
                            <el-option v-for="item in wearNum" :key="item" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="跑步鞋号" prop="track_shoes">
                          <el-select v-model="vitaForm.track_shoes"
                                     placeholder="请选择跑步鞋号">
                            <el-option v-for="item in shoesNum" :key="item" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </fieldset>
                  <!-- 外语 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>外语</legend>
                    <el-row v-for="(col, index) in vitaForm.language_row" :key="index">
                      <el-col :span="6">
                        <!--<el-form-item label="语种"
                                      label-width="50px"
                                      :prop="'language_row.' + index + '.language'"
                                      :rules="{
                                        validator: (rule, value, callback)=>languageValidate(rule, value, callback, index),
                                        trigger: 'change'
                                      }">-->
                        <el-form-item label="语种"
                                      label-width="50px">
                          <el-select v-model="col.language_ids"
                                     filterable
                                     clearable
                                     placeholder="请选择语种">
                            <el-option
                                v-for="item in languageArr"
                                :key="item.language_id"
                                :label="item.zh"
                                :value="item.language_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6"
                              :offset="1">
                        <!--<el-form-item label="口语"
                                      label-width="40px"
                                      :prop="'language_row.' + index + '.spoken'"
                                      :rules="{
                                        validator: (rule, value, callback)=>spokenValidate(rule, value, callback, index),
                                        trigger: 'change'
                                      }">-->
                        <el-form-item label="口语"
                                      label-width="40px">
                          <el-select v-model="col.spoken"
                                     clearable
                                     placeholder="请选择口语熟练度">
                            <el-option
                                v-for="item in language_level"
                                :key="item.val"
                                :label="item.key"
                                :value="item.val">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6"
                              :offset="1">
                        <!--<el-form-item label="书写"
                                      label-width="40px"
                                      :prop="'language_row.' + index + '.written'"
                                      :rules="{
                                        validator: (rule, value, callback)=>writtenValidate(rule, value, callback, index),
                                        trigger: 'change'
                                      }">-->
                        <el-form-item label="书写"
                                      label-width="40px">
                          <el-select v-model="col.written"
                                     clearable
                                     placeholder="请选择书写熟练度">
                            <el-option
                                v-for="item in language_level"
                                :key="item.val"
                                :label="item.key"
                                :value="item.val">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="1"
                              :offset="1">
                        <el-button type="primary"
                                   size="small"
                                   icon="el-icon-plus"
                                   @click="addLanguage"
                                   circle></el-button>
                      </el-col>
                      <el-col :span="1"
                              :offset="1">
                        <el-button v-show="vitaForm.language_row.length !== 1"
                                   type="danger"
                                   size="small"
                                   icon="el-icon-minus"
                                   @click="delLanguage(index)"
                                   circle></el-button>
                      </el-col>
                    </el-row>
                  </fieldset>
                  <!-- 教育经历 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>最高学历</legend>
                    <el-row v-for="(col, index) in vitaForm.academic_qualification" :key="index" class="vita-edu-row">
                      <el-col :span="20">
                        <el-form-item label="起止日期">
                          <el-date-picker
                              v-model="col.time"
                              @change="changeEduTime(index)"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="地点">
                              <el-input v-model.trim="col.academic_address"
                                        placeholder="请输入地点"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="学校">
                              <el-input v-model.trim="col.academic_venue"
                                        placeholder="请输入学校"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="学历/职称">
                              <el-select v-model="col.qualification" placeholder="请选择学历/职称" >
                                <el-option
                                        v-for="item in qualificationList"
                                        :key="item.key"
                                        :label="item.key"
                                        :value="item.value" >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
<!--                          <el-col :span="8">-->
<!--                            <el-form-item label="学历/职称">-->
<!--                              <el-input v-model.trim="col.qualification"-->
<!--                                        placeholder="请输入学历/职称"></el-input>-->
<!--                            </el-form-item>-->
<!--                          </el-col>-->
                          <el-col :span="8">
                            <el-form-item label="证明人">
                              <el-input v-model.trim="col.references_man"
                                        placeholder="请输入证明人"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="联系方式">
                              <el-input v-model.trim="col.contact_details"
                                        placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="4">
                        <el-row class="exp-opt">
                          <el-col :span="6"
                                  :offset="6">
                            <el-button type="primary"
                                       size="small"
                                       icon="el-icon-plus"
                                       @click="addEducationExp"
                                       circle></el-button>
                          </el-col>
                          <el-col :span="8"
                                  :offset="4">
                            <el-button v-show="vitaForm.academic_qualification.length !== 1"
                                       type="danger"
                                       size="small"
                                       icon="el-icon-minus"
                                       @click="delEducationExp(index)"
                                       circle></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>
                  <!-- 等级教练员证书培训历程 -->
                  <!--<fieldset class="vita-form-fieldset">
                    <legend>等级教练员证书培训历程</legend>
                    <el-row v-for="(col, index) in vitaForm.coaching_qualification"
                            class="vita-edu-row">
                      <el-col :span="20">
                        <el-form-item label="起止日期">
                          <el-date-picker
                              v-model="col.time"
                              @change="changeTrainTime(index)"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="地点">
                              <el-input v-model.trim="col.train_address"
                                        placeholder="请输入地点"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="何等级">
                              <el-input v-model.trim="col.train_certificate"
                                        placeholder="请输入等级"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="证书编号">
                              <el-input v-model.trim="col.certificate_number"
                                        placeholder="请输入证书编号"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="主讲师">
                              <el-input v-model.trim="col.train_references"
                                        placeholder="请输入主讲师"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="联系方式">
                              <el-input v-model.trim="col.train_contact_details"
                                        placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="4">
                        <el-row class="exp-opt">
                          <el-col :span="6"
                                  :offset="6">
                            <el-button type="primary"
                                       size="small"
                                       icon="el-icon-plus"
                                       @click="addTrainExp"
                                       circle></el-button>
                          </el-col>
                          <el-col :span="8"
                                  :offset="4">
                            <el-button v-show="vitaForm.coaching_qualification.length !== 1"
                                       type="danger"
                                       size="small"
                                       icon="el-icon-minus"
                                       @click="delTrainExp(index)"
                                       circle></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>-->
                  <!-- 主要执教经历 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>主要执教经历</legend>
                    <el-row v-for="(col, index) in vitaForm.coaching_Experience" :key="index"
                            class="vita-edu-row">
                      <el-col :span="20">
                        <el-form-item label="起止日期">
                          <el-date-picker
                              v-model="col.time"
                              @change="changeTeaTime(index)"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="地点">
                              <el-input v-model.trim="col.coach_address"
                                        placeholder="请输入地点"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="执教球队">
                              <el-input v-model.trim="col.coach_team"
                                        placeholder="请输入执教球队"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="任何职">
                              <el-input v-model.trim="col.coach_position"
                                        placeholder="请输入职位"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="证明人">
                              <el-input v-model.trim="col.coach_references"
                                        placeholder="请输入证明人"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="联系方式">
                              <el-input v-model.trim="col.coach_contact_details"
                                        placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24">
                            <el-form-item label="主要成绩">
                              <el-input v-model.trim="col.coach_achievements"
                                        placeholder="请输入主要成绩" maxlength="200"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="4">
                        <el-row class="exp-opt">
                          <el-col :span="6"
                                  :offset="6">
                            <el-button type="primary"
                                       size="small"
                                       icon="el-icon-plus"
                                       @click="addTeaExp"
                                       circle></el-button>
                          </el-col>
                          <el-col :span="8"
                                  :offset="4">
                            <el-button v-show="vitaForm.coaching_Experience.length !== 1"
                                       type="danger"
                                       size="small"
                                       icon="el-icon-minus"
                                       @click="delTeaExp(index)"
                                       circle></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>
                  <!-- 运动经历 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>主要运动经历</legend>
                    <el-row v-for="(col, index) in vitaForm.playing_experience" :key="index" class="vita-edu-row">
                      <el-col :span="20">
                        <el-form-item label="起止日期">
                          <el-date-picker
                              v-model="col.time"
                              @change="changeSportTime(index)"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="地点">
                              <el-input v-model.trim="col.play_address"
                                        placeholder="请输入地点"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="所在球队">
                              <el-input v-model.trim="col.play_team"
                                        placeholder="请输入所在球队"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="球队级别">
                              <el-select v-model="col.play_team_level"
                                         placeholder="请选择球队级别">
                                <el-option v-for="item in teamList" :key="item.key" :label="item.key" :value="item.value"></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
<!--                          <el-col :span="8">-->
<!--                            <el-form-item label="球队级别">-->
<!--                              <el-input v-model.trim="col.play_team_level"-->
<!--                                        placeholder="请输入球队级别"></el-input>-->
<!--                            </el-form-item>-->
<!--                          </el-col>-->
                          <el-col :span="8">
                            <el-form-item label="主教练">
                              <el-input v-model.trim="col.play_references"
                                        placeholder="请输入主教练"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="联系方式">
                              <el-input v-model.trim="col.play_contact_details"
                                        placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24">
                            <el-form-item label="主要成绩">
                              <el-input v-model.trim="col.play_achievements"
                                        placeholder="请输入主要成绩" maxlength="200"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="4">
                        <el-row class="exp-opt">
                          <el-col :span="6"
                                  :offset="6">
                            <el-button type="primary"
                                       size="small"
                                       icon="el-icon-plus"
                                       @click="addSportExp"
                                       circle></el-button>
                          </el-col>
                          <el-col :span="8"
                                  :offset="4">
                            <el-button v-show="vitaForm.playing_experience.length !== 1"
                                       type="danger"
                                       size="small"
                                       icon="el-icon-minus"
                                       @click="delSportExp(index)"
                                       circle></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>
                </el-form>
              </div>
            </vue-scroll>
          </template>
          <template v-else>
            <yioks-loading></yioks-loading>
          </template>
        </div>
        <div class="btns">
          <el-button type="primary" v-if="false"
            @click="checkForm('edit')"
                     >暂时保存
          </el-button>
          <el-button type="primary"
            @click="checkForm('next')">下一步
          </el-button>
          <el-button type="danger"
                     @click="makeSureBack">取消</el-button>
        </div>
        <yioks-tips :showTips="submitTips"
                    :tips="submitMsg.msg"
                    @hideTips="hideSubmitTips" :loading="loading"></yioks-tips>
        <yioks-tips :showTips="backTips"
                    tips="确定放弃修改并返回吗？"
                    @hideTips="hideBackTips"></yioks-tips>
      </div>
    </template>
  </form-main>
</template>

<script>
  import ops from "@/assets/js/vuescrollOption";
  import fieldMixin from "@/views/Registration/vita/mixin/data-field";
  import uploadMixin from "@/views/Registration/vita/mixin/upload-imgs";
  import optMixin from "@/views/Registration/vita/mixin/exp-options";
  import echoMixin from "@/views/Registration/vita/mixin/data-echo";
  import rulesMixin from "@/views/Registration/vita/mixin/form-rules";
  import {saveInfo} from "@/api/ab_signup/api";
  import { mapMutations } from "vuex";
  import {qualificationList , teamList } from "@/assets/js/select";
  export default {
    name: "vita",
    mixins: [fieldMixin, uploadMixin, optMixin, echoMixin, rulesMixin],
    data() {
      const shoesNum = [];
      for (let i = 0; ; i++) {
        const num = 35+0.5*i;
        if(num > 50) break;
        shoesNum.push(num);
      }
      const wearNum = ['S','M','L','XL','XXL','XXXL'];
      return {
        shoesNum,
        wearNum,
        qualificationList,
        teamList,
        ops: ops(),
        loading:false,
        backTips: false,
        submitTips: false,
        tmpLanguageRow: [],
        tmpEduExp: [],
        qualificationList,
        tmpTrainExp: [],
        tmpTeaExp: [],
        tmpSportsExp: [],
        submitMsg:{
          msg:"",
          submitStatus:""
        }
      };
    },
    components: {
      "form-main": () => import("@/components/LayOut/Common/up-down"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
      "vita-photo": () => import("@/components/UpImage/vita-upload"),
      "yioks-tips": () => import('@/components/Tips/Dialog'),
    },
    methods: {
      ...mapMutations(["updateUserInfo", "updateUserImg"]),
      goBack() {
        this.$router.go(-1);
      },
      makeSureBack() {
        this.backTips = true;
      },
      hideBackTips(bool, flag) {
        if (flag) {
          this.goBack();
        }
        this.backTips = bool;
      },
      checkForm(submit) {
        if(submit === 'next'){
          if (!this.vitaForm.id_card_photo_front) {
            this.$message({
              type: "error",
              message: "请上传身份证正面"
            });
            return;
          }
          if (!this.vitaForm.id_card_photo_verso) {
            this.$message({
              type: "error",
              message: "请上传身份证反面"
            });
            return;
          }
          if (!this.vitaForm.profile_picture) {
            this.$message({
              type: "error",
              message: "请上传二寸白底证件照"
            });
            return;
          }
          this.$refs["vitaForm"].validate((valid) => {
            if (valid) {
              this.translateData();
              this.makeSureSubmit(submit);
            } else {
              this.$message({
                type: "error",
                message: "请完善所有带*号的必填项"
              });
              console.error('error submit!!');
              return false;
            }
          });
        }else{
          this.translateData();
          this.makeSureSubmit(submit);
        }

      },
      translateData() {
        // 出生日期转时间戳
        this.$set(this.vitaForm, "date_of_birth", new Date(this.vitaForm.date_of_birth).getTime());

        let {values} = Object;
        // 外语
        this.tmpLanguageRow = [];
        this.vitaForm.language_row.map((item) => {
          const flag = values(item).some((elem) => {
            return Boolean(elem);
          });
          // console.log("外语" + flag);
          flag && this.tmpLanguageRow.push(item);
        });
        this.tmpLanguageRow.length && this.$set(this.vitaForm, "language_row", this.tmpLanguageRow);

        // 教育经历
        this.tmpEduExp = [];
        this.vitaForm.academic_qualification.map((item) => {
          const flag = values(item).some((elem) => {
            return (elem instanceof Array) ? Boolean(elem.length) : Boolean(elem);
          });
          // console.log("教育经历" + flag);
          if (flag) {
            this.tmpEduExp.push(item);
          }
        });
        this.tmpEduExp.length && this.$set(this.vitaForm, "academic_qualification", this.tmpEduExp);

        // 执教经历
        this.tmpTeaExp = [];
        this.vitaForm.coaching_Experience.map((item) => {
          const flag = values(item).some((elem) => {
            return (elem instanceof Array) ? Boolean(elem.length) : Boolean(elem);
          });
          // console.log("执教经历" + flag);
          if (flag) {
            this.tmpTeaExp.push(item);
          }
        });
        this.tmpTeaExp.length && this.$set(this.vitaForm, "coaching_Experience", this.tmpTeaExp);

        // 运动经历
        this.tmpSportsExp = [];
        this.vitaForm.playing_experience.map((item) => {
          const flag = values(item).some((elem) => {
            return (elem instanceof Array) ? Boolean(elem.length) : Boolean(elem);
          });
          // console.log("运动经历" + flag);
          if (flag) {
            this.tmpSportsExp.push(item);
          }
        });
        this.tmpSportsExp.length && this.$set(this.vitaForm, "playing_experience", this.tmpSportsExp);
      },
      makeSureSubmit(submit) {
        this.submitTips = true;
        this.submitMsg.msg = submit === 'edit' ? "确定暂时保存吗？" : "确定保存并且进入下一步吗？";
        this.submitMsg.submitStatus = submit;
      },
      hideSubmitTips(bool, flag) {
        if (flag) {
          this.submitForm();
          return;
        }
        this.submitTips = bool;
      },
      changePinyin(){
        this.vitaForm. given_name_spell='';
        this.$refs["vitaForm"].validateField("family_name_spell");
      },
      submitForm() {
        this.loading= true;
        const form = {
          ...this.vitaForm,
          language_row: JSON.stringify(this.tmpLanguageRow),
          academic_qualification: JSON.stringify(this.tmpEduExp),
          coaching_qualification: JSON.stringify(this.tmpTrainExp),
          coaching_Experience: JSON.stringify(this.tmpTeaExp),
          playing_experience: JSON.stringify(this.tmpSportsExp),
          submit_status:this.submitMsg.submitStatus
        };
        saveInfo(form)
          .then(({data}) => {
            // console.log(data);
            if (Number(data.status) === 0) {
              // vuex更新个人信息
              this.updateUserInfo({
                ...this.$store.state.userInfo,
                name: this.vitaForm.name.toUpperCase()
              });
              this.updateUserImg(data.result.profile_picture);
              this.$message.success("信息保存成功");
              // 路由跳转
              if(this.submitMsg.submitStatus === 'edit'){
                this.goBack();
                console.log("暂时保存")
              }
              if(this.submitMsg.submitStatus === 'next'){
                this.$router.push({path: 'register_file', query: {signId: this.$route.query.signId}})
              }
            }else if(Number(data.status) === 444) {
              this.$message({
                type: "error",
                message: data.msg
              });
              this.emailErr = true;
              this.emailMsg = data.msg;
              this.$refs["vitaForm"].validateField("email_address");
            }else{
              this.$message.error(data.msg);
            }
            this.loading=false;
            this.submitTips = false;
          })
          .catch((err) => {
            this.loading=false
            console.error(err);
          });
      },
    },
    watch:{
      // switch_pinyin:{
      //   handler(){
      //     //          this.vitaForm. family_name_spell='';
      //     this.vitaForm. given_name_spell='';
      //     this.$refs["vitaForm"].validateField("family_name_spell");
      //   }
      // }
    }
  }
</script>

<style lang="stylus">
  .vita-form-main {
    .content {
      .form-wrap {
        .el-form-item__label {
          color: #fff;
        }
        .vita-edu-row {
          .el-range-separator {
            padding: 0;
          }
        }
        $width = 306px;
        /*.birthday {
          .el-date-editor {
            width: $width;
          }
        }*/
        .gender, .national {
          .el-select {
            width: $width;
          }
        }
      }
    }
  }
</style>
<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  .vita-form-nav, .vita-form-main {
    flex: 1 1 auto;
    height: 100%;
  }

  .vita-form-nav {
    display: flex;
    align-items: center;
    p {
      font-size: $font_size_big;
    }
  }

  .vita-form-main {
    width: 100%;
    .content {
      height: calc(100% - 60px);
      padding: 20px 0;
      position: relative;
      background-color: $block_bg_color_base;
      .form-wrap {
        padding: 0 30px 0 25px;
        .vita-form-fieldset {
          margin: 0 0 20px 0;
          padding: 10px 10px 0;
          border: 1px solid $color_white;
          .photo {
            width: 132px;
            position: relative;
            cursor: pointer;
            .tips-photo {
              display: none;
              width: 345px;
              /*height: 220px;*/
              position: absolute;
              /*top: -30px;*/
              top: 160px;
              /*left: -250px;*/
              left: -180px;
              z-index: 100;
              img {
                width: 100%;
                height: 100%;
              }
            }
            &:hover {
              .tips-photo {
                display: block;
              }
            }
          }
          .idcard-front-end {
            width: 260px;
            position: relative;
            cursor: pointer;
            .front-end-tips {
              display: none;
              width: 345px;
              /*height: 170px;*/
              position: absolute;
              /*top: -5px;*/
              top: 160px;
              left: -40px;
              z-index: 100;
              /*&.front-tips {
                left: 260px;
              }
              &.end-tips {
                right: 260px;
              }*/
              img {
                width: 100%;
                height: 100%;
              }
            }
            &:hover {
              .front-end-tips {
                display: block;
              }
            }
          }
        }
        .vita-edu-row {
          margin: 0 0 10px 0;
          padding: 10px 0 0;
          border: 1px solid $color_white;
        }
        .exp-opt {
          padding: 60px 0 0;
        }
      }
    }
    .btns {
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      /*background-color: $color_err;*/
    }
  }
</style>
